import React from "react";
import "./App.sass";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import GuasasapoTv from "./components/Guasasapotv";
import Introtv from "./components/Introtv";
import comedora from "./img/comedora.png";
import granada from "./img/granada.png";
import guasasapo from "./img/guasasapo.png";
import guasasapotv from "./img/gtv.png";
import trincheta from "./img/trincheta.png";
import Granada from "./components/Granada";
import Trincheta from "./components/Trincheta";
import Comedora from "./components/Comedora";
import Guasasapo from "./components/Guasasapo";

function Home() {
  return (
    <main className="home">
      <div className="home__frame">
        <div className="home__grid">
          <a className="home__mark mark-stamp" href="/guasasapo">
            <img src={guasasapo} alt="Sello Guasasapo" />
          </a>

          <span className="home__mark mark-comedora">
            <img src={comedora} alt="Comedora Vegana y Guasasapo" />
          </span>

          <span className="home__mark mark-trincheta">
            <img src={trincheta} alt="Trincheta" />
          </span>

          <span className="home__mark mark-granada">
            <img src={granada} alt="Granada" />
          </span>

          <a className="home__mark mark-tv" href="https://tv.guasasapo.cl">
            <img src={guasasapotv} alt="Guasasapo TV" />
          </a>
        </div>
      </div>
    </main>
  );
}

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/introtv">
          <Introtv />
        </Route>
        <Route path="/granada">
          <Granada />
        </Route>
        <Route path="/trincheta">
          <Trincheta />
        </Route>
        <Route path="/logos">
          <Home />
        </Route>
        <Route path="/guasasapo">
          <Guasasapo />
        </Route>
        <Route path="/comedora">
          <Comedora />
        </Route>
        <Route path="/guasasapotv">
          <GuasasapoTv />
        </Route>
        <Route path="/guasasapoTV">
          <GuasasapoTv />
        </Route>
        <Route path="/">
          <Guasasapo />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
